import AssemblyMaterialsTable from './AssemblyMaterialsTable';

export default AssemblyMaterialsTable;